import React from 'react';
import {Link} from "react-router-dom";
import '../App.css';
import andyou from '../images/andyou.png';
import deck from '../images/deck.png';
import display from '../images/display.jpeg';
import past from '../images/past.png';
import present from '../images/present.png';
import future from '../images/future.png';
import diary1 from '../images/diary1.jpg';
import diary2 from '../images/diary2.jpeg';


function Andyou(props) {
  return (
    <div className="caseify">
      <div><Link to="/" id="back">(back)</Link></div>
      <div> </div>
      <div id="title">Vietnamese American Imaginaries Exhibit</div>
      <img src={andyou} alt="And You? banner"/>
      <div id="table">
        <div id="tablecol">
          <div id="tablerow">
            <div id="casetitle">Creative brief</div>
            <div id="casetext">What could the Vietnamese American dream look and/or feel like for future generations?</div>
          </div>

          <div id="tablerow">
            <div id="casetitle">Topics</div>
            <div id="casetext">Product design, visual design, card game, Vietnamese diaspora</div>
          </div>
        </div>

        <div id="tablecol">
          <div id="tablerow">
            <div id="casetitle">Partnered with</div>
            <a id="casetext" href="https://flsseattle.org/little-saigon-creative/" target="_blank" rel="noopener noreferrer">
            Little Saigon Creative</a>
          </div>

          <div id="tablerow">
            <div id="casetitle">Timeline</div>
            <div id="casetext">October 2023 - March 2024</div>
          </div>
        </div>
      </div>

      <p>.・。.・゜✭・.・✫・゜・。.</p>

      <div id="tablerow">
        <div id="casetitle">Artist Statement</div>
          <p>Talking is a timeless Vietnamese tradition. Over a table crammed with bowls and beer bottles, the adults are always engaged in 
          lively chatter over the latest gossip, the best deals, and the whereabouts of someone’s children. Those children are no different - 
          playing games and sharing things that we’d never tell our parents. Maybe that’s just how most family gatherings are. We separate ourselves by the 
          language of our conversations and our classification of adult or child (even though all of my cousins, siblings, and I are technically adults now). 
          Actually, what I wanted to do most as a child was</p>
          
          <p>Spend more time with my parents. Namely by playing games together. They understandably did not have the patience to learn the rules of Monopoly and 
          encouraged me to play with my siblings, but it made me sad. I just wanted my family to be like the typical American family I saw on TV. As I grew older, 
          I felt a different sadness as I realized how little I knew about</p>

          <p>My parents and my heritage. By the time I graduated college, all of my grandparents passed away. I felt like I lost a major part of my past after my bà ngoại’s 
          recent passing. How desperately and regretfully I wish I could ask them about their lives. To recover this lost generation, I look to my parents who carry on their 
          stories and the Vietnamese community who share theirs in art, books, poetry, and food. Here, I found beauty in my family’s being and courage from my ancestors who 
          endured history and survived.</p>
      </div>

      <div id="tablerow">
        <div id="casetitle">About</div>
          <p><i>And you? &nbsp;</i> is what you say to reciprocate the question that someone asked you first. It’s also the name of a game for families, friends, and anyone who 
          has felt disconnected from their heritage due to assimilation, language barriers, and/or generational differences. With 18 questions in both English and 
          Vietnamese, I dream of a future where we can play a game together - engaging in conversations as equals, being curious about each other, and connecting our pasts, 
          presents, and futures in the stories we share.</p>

          <p>A future where we tend the garden that grew from the seeds of our stories.</p>

          <a id="casetext" href="https://drive.google.com/file/d/19OHXISFq6QzNDxyRhGnmLo0SgAtq_VfV/view?usp=sharing" target="_blank" rel="noopener noreferrer">
            (Read more about the program)</a>
      </div>

       <div id="tablerow">
        <img id="art" src={display} alt="Display at exhibit"/>
      </div>


      <p>.・。.・゜✭・.・✫・゜・。.</p>

      <div id="tablerow">
        <div id="casetitle">Visual designs</div>
        <p>The gradual consumption of a longan fruit with hues of red, white, and blue from the American flag.</p>
        <img id="art" src={deck} alt="Case and card designs"/>
      </div>

      <div id="tablerow">
        <div id="casetitle">Past</div>
        <p>Encased in a shell. Red symbolizes the blood of the people.</p>
        <img id="art" src={past} alt="6 cards with questions about the past"/>
      </div>

      <div id="tablerow">
        <div id="casetitle">Present</div>
        <p>Flesh. Tangible. The fruit is a gradient between red and blue to symbolize the bridge between past and future.</p>
        <img id="art" src={present} alt="6 cards with questions about the present"/>
      </div>

      <div id="tablerow">
        <div id="casetitle">Future</div>
        <p>The seed of our stories.  Watered with the blue of the ocean, the expansive entity that carried us to new beginnings.</p>
        <img id="art" src={future} alt="6 cards with questions about the future"/>
      </div>

      <div id="tablerow">
        <div id="casetitle">Call me friend</div>
        <p>Most Vietnamese people would cringe at the thought of calling their parents, bạn, or friend. In a Vietnamese conversation, I’m acutely aware of my relation to the other person by age, gender, and social order. 
        In other words, I’m aware of how they perceive me and how they expect me to behave. By calling each other <i>friend&nbsp;</i> instead of <i> mom, dad,</i> or <i>child&nbsp;</i> in this game, I want to twist the conventions of how parents and children 
        talk to each other. Parents were once children who faced their own challenges and had to learn everything they know now. Children have their own identities to explore and stories to tell as they navigate a world that is 
        rapidly changing. A friendship is built upon mutual understanding, empathy, and curiosity, and that is what I hope to facilitate with these questions.</p>
      </div>

      <div id="tablerow">
        <div id="casetitle">Process</div>
        <p>Diary scraps of the journey. I learned that my dad took on a variety of jobs before I was born, like a server at a 
        bustling bánh cuốn restaurant in Orange County and a court interpreter for Vietnamese immigrants, which is why he could help me translate my questions. My mom's love language of
        feeding us fruit also found its way into the design of my cards - longan being one of my favorite fruits to enjoy after a long day at school.</p>
        <p></p>
        <img id="art" src={diary1} alt="Documentation of card design"/>
      </div>

      <div id="tablerow">
        <img id="art" src={diary2} alt="Documentation of display assembly"/>
      </div>

      <p>.・。.・゜✭・.・✫・゜・。.</p>


    </div>
  );
}

export default Andyou;

